import { RegistrationCompleteEvent } from '~/passporter-services/shared/metrics'
import { BaseMetric } from './baseMetric'

export class RegistrationMetric extends BaseMetric {
	static sendRegistrationCompleteEvent(): void {
		new RegistrationCompleteEvent().send(this.gtag)
	}
}
